import React from 'react';
import { useSelector } from 'react-redux';
import { color } from '~/assets/styles/colors';
import {
	HomeOutlined,
	TrendingUpOutlined,
	LinkOutlined,
	Download,
	HelpOutline,
	FaxOutlined,
	PaidOutlined,
	AddCircleOutlined,
	HubOutlined,
	LocalAtmOutlined,
	PointOfSaleOutlined,
	SummarizeOutlined,
	PriceCheckOutlined
} from '@mui/icons-material';
import { SlPeople } from "react-icons/sl";
import { FaHandHoldingUsd } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import ReactGA from 'react-ga4';
import history from '~/services/history';
import { SidebarLi } from '~/components/Header/styles';
import PdfChargBack from '../../../../assets/pdf/PoliticaChargeback.pdf';
import PdfContrato from '../../../../assets/pdf/ContratoDeCredenciamentoEAdesaoDeEstabelecimentos.pdf';




export function ClientSidebar(props) {
	const {  closeSidebars, active } = props;
	const { user } = useSelector((state) => state.auth);

	let redirectTo = '/client/transacoes';

	function handlerDash() {
		if (user.dados.permissoes.view_dashboard) {
			redirectTo = '/client/dashboard';
		}else{
			redirectTo = user.dados.permissoes.view_conciliacao ? '/client/dashboard' : '/client/transacoes';
		}
		handleClickEventGA4("acessar_home_menu")
		history.push(redirectTo)
		closeSidebars();
	}

	function handlerPage(permission, endpoint, reactGA4Event = "") {
		let endpointLink = '';
		if (permission) {
			endpointLink = endpoint;
			if(reactGA4Event){
				handleClickEventGA4(reactGA4Event)
			}
		}else{
			endpointLink = user.dados.permissoes.view_conciliacao ? '/client/dashboard' : '/client/transacoes';
		}

		history.push(endpointLink)
		closeSidebars();
	}

	function handlerFaqLink() {
		const url = "https://lucree.com.br/fale-conosco/";
		window.open(url, '_blank');
		handleClickEventGA4(`acessar_faq_menu`)
	}


	const handleDownload = (tabAtiva) => {
		fetch(tabAtiva === 'termo' ? PdfChargBack : PdfContrato)
			.then(response => response.blob())
			.then(blob => {
				const fileURL = window.URL.createObjectURL(blob);
				const alink = document.createElement('a');
				alink.href = fileURL;

				const nomeArquivo = tabAtiva === 'termo' ? 'Termo_Lucree.pdf' : 'Contrato_Lucree.pdf';
				alink.download = nomeArquivo;

				alink.click();
			});

			handleClickEventGA4(`download_${tabAtiva}_menu`)
	}

	function handleClickEventGA4(message) {
		const newMessage = `${message}_${active ? 'expandido' : 'recolhido'}`
		ReactGA.event({
			category: newMessage,
			action: newMessage,
			label: newMessage,
		});
	}


	const isIndustria = user.dados.cargo.toLowerCase() === 'industria';

	let label = 'Distribuidores';

	if (user.dados.permissoes.view_credito_revenda_distribuidor) {
		if (user.dados.permissoes.view_farmacias) {
			label = 'Farmácias';
		} else {
			label = isIndustria ? 'Distribuidores' : 'Revendedores';
		}
	}

	return (
		<>
			<SidebarLi active={active} onClick={() => handlerDash()}>
				<HomeOutlined style={{color: color.secondary}} />
				<p className="notranslate">Home</p>
			</SidebarLi>


			{user.dados.permissoes.view_meus_pedidos &&
				<SidebarLi active={active} onClick={() => handlerPage(user.dados.permissoes.view_meus_pedidos, '/client/transacoes/pedidos', "acessar_pedidos_menu")}>
					<LocalAtmOutlined style={{color: color.secondary}}  />
					<p>MEUS PEDIDOS</p>
				</SidebarLi>
			}

			{user.dados.permissoes.view_autorizar_credito_revenda &&
				<SidebarLi active={active} onClick={() => handlerPage(user.dados.permissoes.view_autorizar_credito_revenda, '/client/transacoes/autorizar', "acessar_distribuidores_menu")}>
					<LocalAtmOutlined style={{color: color.secondary}}  />
					<p>Distribuidores</p>
				</SidebarLi>
			}


			{user.dados.permissoes.view_autorizar_credito_parceiro &&
				<SidebarLi active={active} onClick={() => handlerPage(user.dados.permissoes.view_autorizar_credito_parceiro, '/client/transacoes/consultaRevendas', "acessar_revendas_menu")}>
					<HubOutlined style={{color: color.secondary}}  />
					<p>REVENDAS</p>
				</SidebarLi>
			}

			{user.dados.permissoes.view_filiais &&
				<SidebarLi active={active} onClick={() => handlerPage(user.dados.permissoes.view_filiais, '/client/transacoes/filiais', "acessar_filiais_menu")}>
					<HubOutlined style={{color: color.secondary}}  />
					<p>FILIAIS</p>
				</SidebarLi>
			}


			{user.dados.permissoes.view_lancamentos &&
				<SidebarLi active={active} onClick={() => handlerPage(user.dados.permissoes.view_lancamentos, '/client/transacoes/lancamentos', "acessar_lancamentos_menu")}>
					<AddCircleOutlined style={{color: color.secondary}}  />
					<p>LANÇAMENTOS</p>
				</SidebarLi>
			}

			{user.dados.permissoes.view_extrato_credito &&
				<SidebarLi active={active} onClick={() => handlerPage(user.dados.permissoes.view_extrato_credito, '/client/transacoes/extrato', "acessar_extrato_menu")}>
					<PaidOutlined style={{color: color.secondary}}  />
					<p>{(user.dados.permissoes.view_labels_pgm_triplo && user.dados.cargo.split(" ")[0].toLowerCase() === 'distribuidor') ? 'EXTRATO DE CRÉDITOS REVENDAS' :  'EXTRATO DE CRÉDITOS'}</p>
				</SidebarLi>
			}

			{(user.dados.permissoes.view_extrato_credito && user.dados.permissoes.view_labels_pgm_triplo && user.dados.cargo.split(" ")[0].toLowerCase() === 'distribuidor') &&
				<SidebarLi active={active} onClick={() => handlerPage(user.dados.permissoes.view_extrato_credito, '/client/transacoes/extratoDistribuidor', "acessar_extrato_menu")}>
					<PaidOutlined style={{color: color.secondary}}  />
					<p>MEU EXTRATO DE CRÉDITO</p>
				</SidebarLi>
			}

			{user.dados.permissoes.view_vendas &&
				<SidebarLi active={active} onClick={() => handlerPage(user.dados.permissoes.view_vendas, '/client/transacoes/vendas', "acessar_vendas_menu")}>
					<PointOfSaleOutlined style={{color: color.secondary}}  />
					<p>VENDAS</p>
				</SidebarLi>
			}


			{(user.dados.permissoes.view_credito_revenda_distribuidor ||
				user.dados.permissoes.view_credito_parceiro) && (
				<SidebarLi
					active={active}
					onClick={() =>
					handlerPage(
						user.dados.permissoes.view_credito_revenda_distribuidor ||
						user.dados.permissoes.view_credito_parceiro,
						'/client/transacoes/credRevenda',
						"acessar_recebimentos_menu"
					)
					}
				>
					<SlPeople style={{ color: color.secondary }} />
					<p>{label}</p>
				</SidebarLi>
			)}

			{user.dados.permissoes.view_recebimentos &&
				<SidebarLi active={active} onClick={() => handlerPage(user.dados.permissoes.view_recebimentos, '/client/transacoes/recebimentos', "acessar_recebimentos_menu")}>
					<PriceCheckOutlined style={{color: color.secondary}}  />
					<p>RECEBIMENTOS</p>
				</SidebarLi>
			}

			{(user.dados.permissoes.detalhamento_financeiro_revenda || user.dados.permissoes.detalhamento_financeiro_participante || user.dados.permissoes.detalhamento_financeiro_industria) &&
				<SidebarLi active={active} onClick={() => handlerPage(user.dados.permissoes.detalhamento_financeiro_revenda || user.dados.permissoes.detalhamento_financeiro_participante || user.dados.permissoes.detalhamento_financeiro_industria, '/client/transacoes/resumo', "acessar_resumo_menu")}>
					<SummarizeOutlined style={{color: color.secondary}}  />
					<p>RESUMO</p>
				</SidebarLi>
			}

			{user.dados.permissoes.view_simulador &&
				<SidebarLi active={active} onClick={() => handlerPage(user.dados.permissoes.view_simulador, '/client/simulador', "acessar_simulador_menu")}>
					<FaxOutlined style={{color: color.secondary}}  />
					<p>SIMULADOR</p>
				</SidebarLi>
			}

			<SidebarLi active={active} onClick={() => handleDownload('termo')}>
				<Download style={{color: color.secondary}}  />
				<p>TERMO</p>
			</SidebarLi>

			<SidebarLi active={active} onClick={() => handleDownload('contrato')}>
				<Download style={{color: color.secondary}}  />
				<p>CONTRATO</p>
			</SidebarLi>

			<SidebarLi active={active} onClick={() => handlerFaqLink()}>
				<HelpOutline style={{color: color.secondary}}  />
				<p className="notranslate">FAQ</p>
			</SidebarLi>

			{/* <SidebarLi onClick={() => history.push('/client/suporte')}>
				<LiveHelpOutlined />
				Suporte
			</SidebarLi> */}
		</>
	);
}

export function ClientSubSidebar(props) {
	const { subSidebar, closeSidebars } = props;
	const { user } = useSelector((state) => state.auth);

	switch (subSidebar) {
		case 'pagamentos':
			return (
				<>
					<div className="mb-4">PAGAMENTOS</div>

					{user.dados.maquina_virtual && (
						<Link
							to="/client/maquina-virtual"
							className="d-block mb-4"
							onClick={closeSidebars}>
							<LinkOutlined className="mr-1" />
							Lucree por click
						</Link>
					)}

					{user.dados.permissoes.view_simulador && (
						<Link
							to="/client/simulador"
							className="d-block mb-4"
							onClick={closeSidebars}>
							<TrendingUpOutlined className="mr-1" />
							Simulador
						</Link>
					)}
				</>
			);
		case 'movimentacoes':
			return (
				<>
					<div className="mb-4">MOVIMENTAÇÕES</div>
					<Link
						to="/client/transacoes"
						className="d-block mb-4"
						onClick={closeSidebars}>
						<FaHandHoldingUsd className="m-1" size={19} />
						{user.dados.permissoes.view_pgm
							? 'Programa de Mercado'
							: 'Vendas e Recebimentos'}
					</Link>
				</>
			);
			default:
			return null;
	}
}
